import React from 'react';
import _ from 'lodash';
import Message from './Message';

let key = 1;
let instances = [];
let instance = null;

const defaultContainerStyle = {
  left: 0,
  top: 6,
};
const defaultContainerClass = '';
const defaultItemStyle = {};
const defaultItemClass = '';
const defaultGetContainer = null;
const defaultDuration = 2000;

let usedContainerClass = defaultContainerClass;
let usedContainerStyle = Object.assign({}, defaultContainerStyle);
let usedItemClass = defaultItemClass;
let usedItemStyle = Object.assign({}, defaultItemStyle);
let usedGetContainer = defaultGetContainer;
let usedDuration = defaultDuration;

function getInstance(callback) {
  if (instance) {
    callback(instance);
    return;
  }
  Message.createInstance({
    containerClass: usedContainerClass,
    containerStyle: usedContainerStyle,
    getContainer: usedGetContainer,
  }, (msgInstance) => {
    if (instance) {
      callback(instance);
      return;
    }
    instance = msgInstance;
    instances.push(msgInstance);
    callback(instance);
  });
}

function show(content = '', {
  itemClass = usedItemClass,
  itemStyle = usedItemStyle,
  duration = usedDuration,
  onClose = () => undefined,
} = {}, type) {
  // eslint-disable-next-line no-underscore-dangle
  const _key = key++;
  let temp = null;
  getInstance((msg) => {
    temp = msg; // 保持对多个instance的引用
    msg.add({
      key: _key,
      content,
      type,
      duration,
      onClose,
      itemClass,
      itemStyle,
    });
  });
  return () => {
    if (temp) {
      temp.remove(_key);
    }
  };
}

const message = {
  info(content, options) {
    return show(content, options, 'info');
  },
  success(content, options) {
    return show(content, options, 'success');
  },
  error(content, options) {
    return show(content, options, 'error');
  },
  warning(content, options) {
    return show(content, options, 'warning');
  },
  loading(content, options) {
    return show(content, options, 'loading');
  },
  resetOptions() {
    usedContainerStyle = Object.assign({}, defaultContainerStyle);
    usedItemStyle = Object.assign({}, defaultItemStyle);
    usedContainerClass = defaultContainerClass;
    usedItemClass = defaultItemClass;
    usedGetContainer = defaultGetContainer;
    usedDuration = defaultDuration;
  },
  setOptions(options) {
    // eslint-disable-next-line object-curly-newline,max-len
    const { containerStyle, containerClass, getContainer, itemStyle, itemClass, duration } = options;
    let needClear = false;
    if (_.isObject(containerStyle)) {
      usedContainerStyle = Object.assign({}, containerStyle);
      needClear = true;
    }
    if (_.isString(containerClass)) {
      usedContainerClass = containerClass;
      needClear = true;
    }
    if (_.isFunction(getContainer)) {
      usedGetContainer = getContainer;
      needClear = true;
    }
    if (_.isObject(itemStyle)) {
      usedItemStyle = Object.assign({}, itemStyle);
    }
    if (_.isString(itemClass)) {
      usedItemClass = itemClass;
    }
    if (_.isNumber(duration)) {
      usedDuration = duration;
    }
    if (needClear) {
      instance = null;
    }
  },
  destroy() {
    instances.forEach((inst) => {
      inst.destroy();
      // eslint-disable-next-line no-param-reassign
      inst = null;
    });
    instances = [];
    if (instance) {
      message.resetOptions();
      // instance.destroy();
      instance = null;
    }
  },
};

export default message;



// WEBPACK FOOTER //
// ./src/components/Message/index.js